function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: ",
        ";\n  ",
        "\n  ",
        "\n  cursor: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  opacity: 0;\n  visibility: hidden;\n  display: none;\n  transition: all 0.3s;\n  &.visible {\n    opacity: 1;\n    visibility: visible;\n    display: block;\n  }\n  font-size: 12px;\n  line-height: 16px;\n  position: ",
        ";\n  bottom: 30px;\n  background-color: rgba(44, 47, 50, 0.92);\n  color: #f5f7fa;\n  padding: ",
        ";\n  ",
        "\n  white-space: normal;\n  font-weight: normal;\n  text-align: left;\n  border-radius: 10px;\n  z-index: 100;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  &:after {\n    content: '';\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-top: 8px solid rgba(44, 47, 50, 0.92);\n    position: absolute;\n    transform: ",
        ";\n    transform-origin: ",
        ";\n    bottom: ",
        ";\n    left: ",
        ";\n    right: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Flex } from 'rebass/styled-components';
import { top, left, right, bottom, height, width, margin, padding } from 'styled-system';
import _ from 'lodash';
import TooltipIcon from './tooltip-icon';
import Clickable from './clickable';
var iconContainerStyles = css(_templateObject(), function(props) {
    return props.iconHeight;
}, function(props) {
    return props.iconOpacity;
});
var IconContainer = styled.div(_templateObject1(), iconContainerStyles);
var ClickableIconContainer = styled(Clickable)(_templateObject2(), iconContainerStyles);
var TooltipContainer = styled(Flex)(_templateObject3(), function(param) {
    var containerWidth = param.containerWidth;
    return containerWidth || 'fit-content';
}, margin, padding, function(param) {
    var cursor = param.cursor;
    return cursor || 'default';
});
var StyledTooltip = styled(function(_param) {
    var _top = _param._top, _left = _param._left, _right = _param._right, _bottom = _param._bottom, _height = _param._height, _width = _param._width, _centerArrow = _param._centerArrow, _margin = _param._margin, props = _object_without_properties(_param, [
        "_top",
        "_left",
        "_right",
        "_bottom",
        "_height",
        "_width",
        "_centerArrow",
        "_margin"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread({}, props));
})(_templateObject4(), function(param) {
    var mobilePosition = param.mobilePosition;
    return (mobilePosition === null || mobilePosition === void 0 ? void 0 : mobilePosition.right) && "\n    @media screen and (max-width: 410px) {\n      right: ".concat(mobilePosition.right, ";\n    }\n  ");
}, function(param) {
    var position = param.position;
    return position;
}, function(props) {
    return props.bubblePadding || '15px 18px 16px 21px';
}, margin, top, left, right, bottom, height, width, function(props) {
    return props.leftArrow ? 'rotate(90deg) translateX(25%)' : 'none';
}, function(props) {
    return props.leftArrow ? 'center' : 'top left';
}, function(props) {
    return props.leftArrow ? '50%' : '-7px';
}, function(props) {
    return props.leftArrow ? '-11px' : 'auto';
}, function(props) {
    if (props.centerArrow) {
        return 'calc(50% - 8px)';
    }
    if (props.arrowRight) {
        return props.arrowRight;
    }
    return '61px';
});
var Tooltip = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(Tooltip, _React_Component);
    function Tooltip(props) {
        _class_call_check(this, Tooltip);
        var _this;
        _this = _call_super(this, Tooltip, [
            props
        ]);
        _this.state = {
            hover: props.show
        };
        return _this;
    }
    _create_class(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, mainCopy = _this_props.mainCopy, tooltipCopy = _this_props.tooltipCopy, hoverMain = _this_props.hoverMain, centerArrow = _this_props.centerArrow, tooltipLink = _this_props.tooltipLink, hideIcon = _this_props.hideIcon, icon = _this_props.icon, _this_props_iconOpacity = _this_props.iconOpacity, iconOpacity = _this_props_iconOpacity === void 0 ? 1 : _this_props_iconOpacity, _this_props_allowHoverAction = _this_props.allowHoverAction, allowHoverAction = _this_props_allowHoverAction === void 0 ? true : _this_props_allowHoverAction, topProp = _this_props.top, leftProp = _this_props.left, rightProp = _this_props.right, bottomProp = _this_props.bottom, heightProp = _this_props.height, widthProp = _this_props.width, visible = _this_props.visible, position = _this_props.position, marginProp = _this_props.margin, mobilePosition = _this_props.mobilePosition, _this_props_iconHeight = _this_props.iconHeight, iconHeight = _this_props_iconHeight === void 0 ? '15px' : _this_props_iconHeight, props = _object_without_properties(_this_props, [
                    "mainCopy",
                    "tooltipCopy",
                    "hoverMain",
                    "centerArrow",
                    "tooltipLink",
                    "hideIcon",
                    "icon",
                    "iconOpacity",
                    "allowHoverAction",
                    "top",
                    "left",
                    "right",
                    "bottom",
                    "height",
                    "width",
                    "visible",
                    "position",
                    "margin",
                    "mobilePosition",
                    "iconHeight"
                ]);
                var hover = this.state.hover;
                return /*#__PURE__*/ _jsxs(TooltipContainer, _object_spread_props(_object_spread({}, props), {
                    children: [
                        hoverMain && /*#__PURE__*/ React.cloneElement(mainCopy, {
                            onMouseEnter: function() {
                                return allowHoverAction ? _this.setState({
                                    hover: true
                                }) : _.noop();
                            },
                            onMouseLeave: function() {
                                return allowHoverAction ? _this.setState({
                                    hover: false
                                }) : _.noop();
                            },
                            onFocus: function() {
                                return allowHoverAction ? _this.setState({
                                    hover: true
                                }) : _.noop();
                            },
                            onBlur: function() {
                                return allowHoverAction ? _this.setState({
                                    hover: false
                                }) : _.noop();
                            }
                        }),
                        !hoverMain && mainCopy,
                        !hoverMain && !tooltipLink && !hideIcon && /*#__PURE__*/ _jsx(IconContainer, {
                            onMouseEnter: function() {
                                return _this.setState({
                                    hover: true
                                });
                            },
                            onMouseLeave: function() {
                                return _this.setState({
                                    hover: false
                                });
                            },
                            iconOpacity: iconOpacity,
                            iconHeight: iconHeight,
                            children: /*#__PURE__*/ _jsx(TooltipIcon, _object_spread({
                                color: props.grey && 'grey'
                            }, icon))
                        }),
                        !hoverMain && tooltipLink && /*#__PURE__*/ _jsx(ClickableIconContainer, {
                            onClick: function() {
                                return window.open(tooltipLink, "_blank");
                            },
                            iconOpacity: iconOpacity,
                            children: /*#__PURE__*/ _jsx(TooltipIcon, _object_spread({
                                color: props.grey && 'grey'
                            }, icon))
                        }),
                        tooltipCopy && /*#__PURE__*/ _jsx(StyledTooltip, {
                            className: (hover || visible) && 'visible',
                            top: topProp || 'auto',
                            left: leftProp || 'auto',
                            right: rightProp || '-61px',
                            bottom: bottomProp,
                            height: heightProp || 'auto',
                            width: widthProp || '239px',
                            centerArrow: centerArrow,
                            arrowRight: props.arrowRight,
                            bubblePadding: props.bubblePadding,
                            leftArrow: props.leftArrow,
                            position: position || 'absolute',
                            margin: marginProp || 'unset',
                            mobilePosition: mobilePosition,
                            children: /*#__PURE__*/ _jsx("p", {
                                className: "tooltip-copy",
                                children: tooltipCopy
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return Tooltip;
}(React.Component);
export { Tooltip as default };
